import React from 'react';
import ComponentCreator from '@docusaurus/ComponentCreator';

export default [
  {
    path: '/pl/501/',
    component: ComponentCreator('/pl/501/', 'd0c'),
    exact: true
  },
  {
    path: '/pl/articles/',
    component: ComponentCreator('/pl/articles/', 'bb3'),
    exact: true
  },
  {
    path: '/pl/articles/2024/07/09/diskusija-lj-nj-cyrl/',
    component: ComponentCreator('/pl/articles/2024/07/09/diskusija-lj-nj-cyrl/', 'f01'),
    exact: true
  },
  {
    path: '/pl/articles/2024/07/09/diskusija-lj-nj/',
    component: ComponentCreator('/pl/articles/2024/07/09/diskusija-lj-nj/', '111'),
    exact: true
  },
  {
    path: '/pl/articles/archive/',
    component: ComponentCreator('/pl/articles/archive/', 'c3a'),
    exact: true
  },
  {
    path: '/pl/articles/authors/',
    component: ComponentCreator('/pl/articles/authors/', '413'),
    exact: true
  },
  {
    path: '/pl/search/',
    component: ComponentCreator('/pl/search/', 'd4d'),
    exact: true
  },
  {
    path: '/pl/',
    component: ComponentCreator('/pl/', '98d'),
    exact: true
  },
  {
    path: '/pl/',
    component: ComponentCreator('/pl/', '089'),
    routes: [
      {
        path: '/pl/',
        component: ComponentCreator('/pl/', 'd3c'),
        routes: [
          {
            path: '/pl/tags/',
            component: ComponentCreator('/pl/tags/', '0ed'),
            exact: true
          },
          {
            path: '/pl/tags/comparative/',
            component: ComponentCreator('/pl/tags/comparative/', 'd76'),
            exact: true
          },
          {
            path: '/pl/tags/gramatyka/',
            component: ComponentCreator('/pl/tags/gramatyka/', 'd76'),
            exact: true
          },
          {
            path: '/pl/tags/grammar/',
            component: ComponentCreator('/pl/tags/grammar/', 'd3f'),
            exact: true
          },
          {
            path: '/pl/tags/interslavic/',
            component: ComponentCreator('/pl/tags/interslavic/', '452'),
            exact: true
          },
          {
            path: '/pl/tags/jezyk-miedzyslowianski/',
            component: ComponentCreator('/pl/tags/jezyk-miedzyslowianski/', 'd9d'),
            exact: true
          },
          {
            path: '/pl/tags/language-learning/',
            component: ComponentCreator('/pl/tags/language-learning/', '0d9'),
            exact: true
          },
          {
            path: '/pl/tags/linguistics/',
            component: ComponentCreator('/pl/tags/linguistics/', '987'),
            exact: true
          },
          {
            path: '/pl/tags/miedzyslowianski/',
            component: ComponentCreator('/pl/tags/miedzyslowianski/', '27f'),
            exact: true
          },
          {
            path: '/pl/tags/nauka-jezyka/',
            component: ComponentCreator('/pl/tags/nauka-jezyka/', 'fb8'),
            exact: true
          },
          {
            path: '/pl/tags/personal-pronouns/',
            component: ComponentCreator('/pl/tags/personal-pronouns/', '519'),
            exact: true
          },
          {
            path: '/pl/tags/porownanie-jezykow/',
            component: ComponentCreator('/pl/tags/porownanie-jezykow/', 'b3a'),
            exact: true
          },
          {
            path: '/pl/tags/pronouns/',
            component: ComponentCreator('/pl/tags/pronouns/', '176'),
            exact: true
          },
          {
            path: '/pl/tags/slavic-languages/',
            component: ComponentCreator('/pl/tags/slavic-languages/', '89b'),
            exact: true
          },
          {
            path: '/pl/tags/zaimki/',
            component: ComponentCreator('/pl/tags/zaimki/', '1e5'),
            exact: true
          },
          {
            path: '/pl/',
            component: ComponentCreator('/pl/', '098'),
            routes: [
              {
                path: '/pl/learn/faq/',
                component: ComponentCreator('/pl/learn/faq/', '45b'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/pl/learn/grammar/',
                component: ComponentCreator('/pl/learn/grammar/', '4d8'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/pl/learn/grammar/adjectives/',
                component: ComponentCreator('/pl/learn/grammar/adjectives/', 'cfc'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/pl/learn/grammar/conjunctions/',
                component: ComponentCreator('/pl/learn/grammar/conjunctions/', '087'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/pl/learn/grammar/nouns/',
                component: ComponentCreator('/pl/learn/grammar/nouns/', '899'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/pl/learn/grammar/numerals/',
                component: ComponentCreator('/pl/learn/grammar/numerals/', '6f9'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/pl/learn/grammar/prepositions/',
                component: ComponentCreator('/pl/learn/grammar/prepositions/', '4e1'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/pl/learn/grammar/pronouns/',
                component: ComponentCreator('/pl/learn/grammar/pronouns/', 'e03'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/pl/learn/grammar/syntax/',
                component: ComponentCreator('/pl/learn/grammar/syntax/', 'dd8'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/pl/learn/grammar/verbs/',
                component: ComponentCreator('/pl/learn/grammar/verbs/', '9dc'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/pl/learn/introduction/',
                component: ComponentCreator('/pl/learn/introduction/', 'aa9'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/pl/learn/misc/constructed-slavic-languages/',
                component: ComponentCreator('/pl/learn/misc/constructed-slavic-languages/', 'b03'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/pl/learn/misc/design-criteria/',
                component: ComponentCreator('/pl/learn/misc/design-criteria/', 'ddb'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/pl/learn/misc/history/',
                component: ComponentCreator('/pl/learn/misc/history/', 'dcf'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/pl/learn/misc/language-comparison/',
                component: ComponentCreator('/pl/learn/misc/language-comparison/', '714'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/pl/learn/misc/numbers-1-10/',
                component: ComponentCreator('/pl/learn/misc/numbers-1-10/', '3ce'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/pl/learn/misc/pan-slavic-relay/',
                component: ComponentCreator('/pl/learn/misc/pan-slavic-relay/', 'ad5'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/pl/learn/misc/personal-pronouns/',
                component: ComponentCreator('/pl/learn/misc/personal-pronouns/', '2c2'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/pl/learn/orthography/',
                component: ComponentCreator('/pl/learn/orthography/', '115'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/pl/learn/phonology/',
                component: ComponentCreator('/pl/learn/phonology/', '5b1'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/pl/learn/pronunciation/',
                component: ComponentCreator('/pl/learn/pronunciation/', '823'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/pl/learn/simple-grammar/',
                component: ComponentCreator('/pl/learn/simple-grammar/', '228'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/pl/learn/simple-grammar/level-1/',
                component: ComponentCreator('/pl/learn/simple-grammar/level-1/', 'da0'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/pl/learn/simple-grammar/level-2/',
                component: ComponentCreator('/pl/learn/simple-grammar/level-2/', '347'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/pl/learn/vocabulary/derivation/',
                component: ComponentCreator('/pl/learn/vocabulary/derivation/', '405'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/pl/learn/vocabulary/flavourisation/',
                component: ComponentCreator('/pl/learn/vocabulary/flavourisation/', 'bba'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/pl/learn/vocabulary/word-formation/',
                component: ComponentCreator('/pl/learn/vocabulary/word-formation/', '8d2'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/pl/resources/',
                component: ComponentCreator('/pl/resources/', 'e9f'),
                exact: true,
                sidebar: "resourcesSidebar"
              },
              {
                path: '/pl/resources/applets/',
                component: ComponentCreator('/pl/resources/applets/', 'ba5'),
                exact: true,
                sidebar: "resourcesSidebar"
              },
              {
                path: '/pl/resources/applets/intelligibility/',
                component: ComponentCreator('/pl/resources/applets/intelligibility/', '2f5'),
                exact: true,
                sidebar: "resourcesSidebar"
              },
              {
                path: '/pl/resources/applets/transliterator/',
                component: ComponentCreator('/pl/resources/applets/transliterator/', '6b4'),
                exact: true,
                sidebar: "resourcesSidebar"
              },
              {
                path: '/pl/resources/keyboards/',
                component: ComponentCreator('/pl/resources/keyboards/', 'fd1'),
                exact: true,
                sidebar: "resourcesSidebar"
              }
            ]
          }
        ]
      }
    ]
  },
  {
    path: '*',
    component: ComponentCreator('*'),
  },
];
